<p>
  send-order-confirm-modal works!
</p>
